// Shared print utilities for all report pages

// Safer alternative to document.write — sets innerHTML on the new window/iframe document.
// document.write is treated as a deprecated/XSS-risk surface by linters; this preserves the
// same UX while writing through the DOM instead of the parser.
export const writePrintDoc = (doc, htmlContent) => {
  // Split <head> and <body> contents so we can assign them via innerHTML.
  doc.open();
  doc.close();
  const m = htmlContent.match(/<head[^>]*>([\s\S]*?)<\/head>[\s\S]*?<body[^>]*>([\s\S]*?)<\/body>/i);
  if (m) {
    doc.head.innerHTML = m[1];
    doc.body.innerHTML = m[2];
  } else {
    doc.body.innerHTML = htmlContent;
  }
};

const _writeToDoc = writePrintDoc;

export const openPrintWindow = (htmlContent) => {
  const pw = window.open('', '_blank');
  if (!pw) {
    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
    document.body.appendChild(iframe);
    _writeToDoc(iframe.contentDocument, htmlContent);
    setTimeout(() => { iframe.contentWindow.print(); setTimeout(() => document.body.removeChild(iframe), 1000); }, 500);
    return;
  }
  _writeToDoc(pw.document, htmlContent);
  setTimeout(() => pw.print(), 500);
};

export const buildPrintHTML = (title, bodyContent, branchName = 'All Branches') => {
  return `<html><head><title>${title} - WWAGS MIS</title>
    <style>
      body{font-family:Arial,sans-serif;font-size:11px;padding:20px;margin:0}
      h1{color:#047857;font-size:18px;margin-bottom:5px;text-align:center}
      h2{font-size:14px;color:#333;margin-bottom:5px;text-align:center}
      h3{font-size:12px;color:#047857;margin:15px 0 8px;border-bottom:1px solid #047857;padding-bottom:3px}
      .info{text-align:center;font-size:10px;color:#666;margin-bottom:15px}
      table{width:100%;border-collapse:collapse;margin:10px 0 15px}
      th,td{border:1px solid #ddd;padding:5px 7px;text-align:left}
      th{background:#047857;color:#fff;font-size:10px}
      td{font-size:10px}
      .cards{display:flex;gap:10px;justify-content:center;flex-wrap:wrap;margin:15px 0}
      .card{border:1px solid #ddd;border-radius:6px;padding:8px 16px;text-align:center;min-width:100px;background:#f9f9f9}
      .card b{display:block;font-size:14px;margin:2px 0}
      .card small{font-size:9px;color:#666}
      .total-row{background:#f0fdf4;font-weight:bold}
      .footer{margin-top:20px;font-size:9px;color:#666;text-align:center;border-top:1px solid #ddd;padding-top:10px}
      @media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}@page{margin:10mm}}
    </style></head>
    <body>
      <h1>WWAGS MIS Portal</h1>
      <h2>${title}</h2>
      <div class="info">Branch: ${branchName} | Generated: ${new Date().toLocaleString('en-IN')}</div>
      ${bodyContent}
      <div class="footer">MIS Developed by Institute of Skill Development and Entrepreneurship (ISDE), Manipur</div>
    </body></html>`;
};
